import ActionsTable from './ActionsTable'

export default ActionsTable
